// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import { getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputPhoneNumber,
    processEntityOutput as processEntityOutputPhoneNumber
} from '../phone-number';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    ...processEntityInputSafeDeleter(values),
    phoneNumbers: values?.phoneNumbers
        ?.map((phoneNumber) => processEntityInputPhoneNumber(phoneNumber))
        ?.sort((pn1, pn2) => (pn1.createdAt < pn2.createdAt ? 1 : -1))
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    user: 'user' in (values || {}) ? getIriFromObj(values.user) : undefined,
    department: 'department' in (values || {}) ? getIriFromObj(values.department) : undefined,
    phoneNumbers:
        'phoneNumbers' in (values || {}) && Array.isArray(values.phoneNumbers)
            ? values.phoneNumbers.map((phoneNumber) => processEntityOutputPhoneNumber(phoneNumber))
            : undefined
});
